import React, { PropTypes, Component } from "react"
import { Form } from "react-redux-form/immutable"
import { Fieldset, Row, Field } from "react-gridforms"

import Input from "components/Input"
import FieldGroupRow from "components/FieldGroupRow"

class EnrolledDetail extends Component {
  _onRequestWithdraw = () => {
    this.props.onRequestWithdraw(this.props.item.get("id"), false)
  }

  _onRequestWithdrawUndo = () => {
    this.props.onRequestWithdraw(this.props.item.get("id"), true)
  }

  render() {
    const { model, item, pending } = this.props
    let action = null
    if (item.get("action") === 0) {
      // enrolled subject
      action = (
        <button
          onClick={this._onRequestWithdraw}
          type="button"
          className="btn btn-danger"
        >
          Request 'Withdraw Subject'
        </button>
      )
    }
    if (item.get("action") === 2) {
      // undo request
      action = (
        <button
          onClick={this._onRequestWithdrawUndo}
          type="button"
          className="btn btn-warning"
        >
          Undo 'Withdraw Subject' request
        </button>
      )
    }

    return (
      <Form model={model} className="grid-form">
        <Fieldset legend="Subject Detail" disabled>
          <Row>
            <Field>
              <Input model=".subject_code" label="Subject Code" />
            </Field>
            <Field>
              <Input model=".section" label="Section" />
            </Field>
          </Row>
          <FieldGroupRow model=".subject_name" label="Subject Description" />
          <FieldGroupRow model=".schedule" label="Schedule" />
          <FieldGroupRow model=".instructor_name" label="Instructor" />
          <Row>
            <Field>
              <Input model=".lec_units" label="Lec Units" />
            </Field>
            <Field>
              <Input model=".lab_units" label="Lab Units" />
            </Field>
            <Field>
              <Input model=".units" label="Units" />
            </Field>
          </Row>
        </Fieldset>
        <fieldset className="modal-footer" disabled={pending}>
          {action}
        </fieldset>
      </Form>
    )
  }
}

EnrolledDetail.propTypes = {
  model: PropTypes.string,
  item: PropTypes.object,
  pending: PropTypes.bool,
}

export default EnrolledDetail



// WEBPACK FOOTER //
// ./src/containers/Enrolment/AddWithdraw/enrolled-detail.js